import { render, staticRenderFns } from "./dictEdit.vue?vue&type=template&id=044c4493&scoped=true"
import script from "./dictEdit.vue?vue&type=script&lang=js"
export * from "./dictEdit.vue?vue&type=script&lang=js"
import style0 from "./dictEdit.vue?vue&type=style&index=0&id=044c4493&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044c4493",
  null
  
)

export default component.exports